/** @format */

/**
 * Infer file parse options from the user's chat message (no separate output dropdown).
 * @param {string} prompt - Text from the chat input when Send is clicked with a file attached.
 * @returns {{ outputFormat: 'raw'|'json'|'csv'|'text', instruction: string }}
 */
export function inferFileUploadFromPrompt(prompt) {
  const text = (prompt || '').trim();
  if (!text) {
    return { outputFormat: 'raw', instruction: '' };
  }

  const lower = text.toLowerCase();

  if (
    /\bcsv\b/.test(lower) ||
    /\bcomma[\s-]?separated\b/.test(lower) ||
    /\bas\s+(a\s+)?csv\b/.test(lower) ||
    /\bto\s+csv\b/.test(lower)
  ) {
    return { outputFormat: 'csv', instruction: text };
  }

  if (/\bjson\b/.test(lower) || /\bas\s+(a\s+)?json\b/.test(lower) || /\bto\s+json\b/.test(lower)) {
    return { outputFormat: 'json', instruction: text };
  }

  return { outputFormat: 'text', instruction: text };
}
